(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.apps.Alerts.module('enums');
        RivalIQ.apps.Alerts.enums.performanceSegmentType = definition();

    }

    function definition() {

        return {
            ADSET: 'adset',
            AGE_GENDER: 'age_gender',
            PLACEMENT: 'placement'
        };

    }
})();
